import ArgonTypography from 'components/ArgonTypography'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

import ArgonBox from "components/ArgonBox";


import Card from "@mui/material/Card";

// Argon Dashboard 2 MUI components


// Argon Dashboard 2 MUI examples
import Footer from "examples/Footer";

import {CardContent, Divider } from "@mui/material";


import { useState,useEffect } from "react";

import {Grid } from "@mui/material";
import ArgonInput from 'components/ArgonInput';
import ArgonButton from 'components/ArgonButton';
import Table from 'examples/Tables/Table';
import SummaryTableData from "Views/Activities/ClassMgt/data/summaryTableData"
import Dropdown from 'components/CustomDropdown/Dropdown';


function AddTutor() {

    const {columns,rows} = SummaryTableData;

      const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    designation: "",
    password: "",
    profileImage: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  //profile image show k liye code 
    const [preview, setPreview] = useState(null);

    const handleChange1 = (e) => {
    const file = e.target.files[0];
    if (file) {
      // File ko URL me convert karke state me store karo
      setPreview(URL.createObjectURL(file));
    }
  };
    //profile image show k liye code end

   const [EditingOpen, setIsEditingClose] = useState(false);

  const handleEdit = () => {
    console.log("edit clicked");
    setIsEditingClose(true);
  };
  const handleClose = () => {
    setIsEditingClose(false);
  }

  const[status,setStatus] = useState("")
  const[gender,setGender] = useState("")
  const[modeOfTuition,setModeOfTuition] = useState("")
  const[state,setState] = useState("")

  return (

   <DashboardLayout>
      <DashboardNavbar />

      <ArgonBox py={3}>

     <Card
  sx={{
    width: "100%",
    borderRadius: "1rem",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    overflow: "hidden",
  }}
>
  {/* Header */}
  <ArgonBox
    sx={{
      background: "linear-gradient(90deg, #1976D2, #42A5F5)",
      px: 3,
      py: 2,
    }}
  >
    <ArgonTypography variant="h6" fontWeight="bold" color="white">
      Parent Basic Detail
    </ArgonTypography>
  </ArgonBox>

  {/* Content */}
  <CardContent sx={{ px: 3, py: 2 }}>
    <Grid container spacing={2}>
      {/* Card Item */}
      {[
        { label: "Parent Name", value: "Rajesh Sharma" },
        { label: "Mobile No", value: "+91 9876543210" },
        { label: "Gender", value: "Male" },
        { label: "Email Address", value: "rajesh.sharma@example.com" },
        { label: "Mode of Tuition", value: "Online" },
        { label: "Location", value: "Sector 62, Noida" },
        { label: "State", value: "Uttar Pradesh" },
        { label: "City", value: "Noida" },
      ].map((item, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            sx={{
              borderRadius: "0.75rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              p: 2,
              height: "100%",
              background: "linear-gradient(180deg, #fafafa, #fff)",
              transition: "0.3s",
              "&:hover": { boxShadow: "0 4px 14px rgba(0,0,0,0.15)" },
            }}
          >
            <ArgonTypography
              variant="caption"
              color="text.secondary"
              sx={{ fontWeight: "medium", letterSpacing: 0.5 }}
            >
              {item.label}
            </ArgonTypography>
            <ArgonTypography
              variant="body2"
              fontWeight="medium"
              color="dark"
              sx={{ mt: 0.5 }}
            >
              {item.value}
            </ArgonTypography>
          </Card>
        </Grid>
      ))}
    </Grid>
  </CardContent>

  {/* Footer Button */}
  <ArgonBox
    display="flex"
    justifyContent="flex-end"
    p={2}
    sx={{ backgroundColor: "rgb(250,250,250)" }}
  >
    <ArgonButton
      onClick={handleEdit}
      variant="contained"
      color="primary"
      sx={{
        borderRadius: "0.5rem",
        textTransform: "none",
        fontWeight: "medium",
        px: 3,
      }}
    >
      Edit Details
    </ArgonButton>
  </ArgonBox>
</Card>


    
      </ArgonBox>

        <ArgonBox py={3}>
                <ArgonTypography variant="body1" fontWeight="medium" sx={{px:3}} mb={2} >Student List</ArgonTypography>
                 <ArgonBox
                          sx={{
                            "& .MuiTableRow-root:not(:last-child)": {
                              "& td": {
                                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                  `${borderWidth[1]} solid ${borderColor}`,
                              },
                            },
                          }}
                        >
                          <Table columns={columns} rows={rows} />
                        </ArgonBox>
            </ArgonBox>

            {/* handleEdit */}
              {/* Dialog */}
      <Dialog
        open={EditingOpen}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "0.75rem", p: 1 },
        }}
      >
        <DialogTitle>
          <ArgonTypography variant="h6" fontWeight="bold" color="dark">
            Edit Parent Details
          </ArgonTypography>
        </DialogTitle>
        <Divider />

        <DialogContent >
          <Grid container spacing={2}>
            {/* Parent Name */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Parent Name</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Name"
                  size="medium"
                />
            </Grid>

            {/* Parent Last Name */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Parent Last Name</ArgonTypography>
              <ArgonInput
              fullWidth
              placeholder="Enter Last Name"
              />
            </Grid>

            {/* Email */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Email</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Email Address"
                
                />
            </Grid>

            {/* Mobile */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Mobile No</ArgonTypography>
                <ArgonInput
                fullWidth
                placeholder="Enter Mobile No"
              
                />
              
            </Grid>

            {/* Gender */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select Gender</ArgonTypography>
                <Dropdown
                  value={gender}
                  options={["Male", "Female", "Other"]}
                  onChange={(e) => setGender(e.target.value)}
                  width="100%"
                />
            </Grid>

            {/* Mode of Tuition */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select Mode of Tuition</ArgonTypography>
              <Dropdown
                value={modeOfTuition}
                options={["Online", "Offline"]}
                onChange={(e) => setModeOfTuition(e.target.value)}
                width="100%"
              />
            </Grid>

            {/* State */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Select State</ArgonTypography>
                <Dropdown
                 value={state}
                 options={["Uttar Pradesh", "Delhi", "Haryana"]}
                 onChange={(e) => setState(e.target.value)}
                 width="100%"
                />
              
            </Grid>

            {/* Location */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter Location</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter Location"
                
                />
            </Grid>

            {/* City */}
            <Grid item xs={12} md={6}>
                <ArgonTypography variant="body2" color="text" fontWeight="medium">Enter City</ArgonTypography>
                <ArgonInput
                  fullWidth
                  placeholder="Enter City"
                />
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <ArgonBox
            display="flex"
            justifyContent="flex-end"
            gap={1.5}
            mt={3}
          >
            <ArgonButton
              variant="outlined"
              color="secondary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                fontSize: "0.8rem",
                px: 2,
                py: 0.5,
                borderRadius: "0.4rem",
              }}
            >
              Cancel
            </ArgonButton>
            <ArgonButton
              type="submit"
              variant="contained"
                color="primary"
            >
              Save
            </ArgonButton>
          </ArgonBox>
        </DialogContent>
      </Dialog>

      <Footer />
    </DashboardLayout>

  )
}

export default AddTutor